import { Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Header from './components/Header';
import Home from './pages/Home';
import Menu from './pages/Menu';
import About from './pages/About';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';
import Reservation from './pages/Reservation';

function App() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <ThemeProvider>
            <LanguageProvider>
                <div className="min-h-screen bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100">
                    <Header />
                    <main className="flex-1">
                        <AnimatePresence mode="wait">
                            <Routes>
                                <Route path="/" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <Home />
                                    </motion.div>
                                } />
                                <Route path="/menu" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <Menu />
                                    </motion.div>
                                } />
                                <Route path="/about" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <About />
                                    </motion.div>
                                } />
                                <Route path="/gallery" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <Gallery />
                                    </motion.div>
                                } />
                                <Route path="/contact" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <Contact />
                                    </motion.div>
                                } />
                                <Route path="/reservation" element={
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        exit={{ opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <Reservation />
                                    </motion.div>
                                } />
                            </Routes>
                        </AnimatePresence>
                    </main>
                </div>
            </LanguageProvider>
        </ThemeProvider>
    );
}

export default App;
